import { Component, OnInit } from '@angular/core';
import {PageService} from "../../service/page/page.service";
import {PageHomeMemberPost} from "../../service/page/page";

@Component({
  selector: 'app-home-member',
  templateUrl: './home-member.component.html',
  styleUrls: ['./home-member.component.scss'],
  providers: [PageService]
})
export class HomeMemberComponent implements OnInit {

  homeMemberPost: PageHomeMemberPost;

  constructor(private pageService: PageService) {
    this.pageService.getHomeMember().subscribe(
      homeMemberPost => {
        this.homeMemberPost = homeMemberPost;
        if(this.homeMemberPost.teams.length > 7)
          this.homeMemberPost.teams.splice(7, 1);
      }
    );
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home-member/home-member.component.ts